import { Icon } from "@utdanningsdirektoratet/icon";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";
import * as React from "react";
import styles from "./MenuPanel.module.less";

export const Banner: React.FC = () => {
  const lesetilgangMessage = (
    <div className={styles.menuPanelBannerTooltip}>
      Du har lesetilgang. Det betyr at du kan kan lese, men ikke gjøre endringer. Kontakt tjenesteansvarlig hvis du har behov for endring i
      tilganger. Oversikt over tjenesteansvarlige finner du i{" "}
      <a href="https://systemoversikten.udir.no/systemer/S270/detaljer" target="_blank" rel="noreferrer">
        Systemoversikten
      </a>
      .
    </div>
  );
  return (
    <div className={styles.menuPanelBanner}>
      <Tooltip message={lesetilgangMessage} position="bottom" interactive>
        <div className={styles.menuPanelBannerContent} aria-label="Du har lesetilgang">
          <Icon icon="eye open" className={styles.menuPanelBannerIcon} />
          LESETILGANG
        </div>
      </Tooltip>
    </div>
  );
};
